// store/slices/clientSlice.ts
import { StateCreator } from "zustand";
import { Client } from "@/types";

export interface ClientSlice {
  clients: Client[];
  selectedClient: Client | null;
  setClients: (clients: Client[]) => void;
  setSelectedClient: (client: Client | null) => void;
}

export const createClientSlice: StateCreator<ClientSlice> = (set) => ({
  clients: [],
  selectedClient: null,
  setClients: (clients) => set({ clients }),
  setSelectedClient: (selectedClient) => set({ selectedClient }),
});
